export function Survey(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.7666 7.17035C4.95915 7.17035 5.11523 7.01426 5.11523 6.82172C5.11523 6.62575 5.17562 6.45599 5.29639 6.31244C5.41715 6.16888 5.7168 5.94216 6.19531 5.63226C6.76042 5.27224 7.17171 4.89056 7.4292 4.48724C7.68669 4.08392 7.81543 3.60655 7.81543 3.05511C7.81543 2.28493 7.52604 1.67653 6.94727 1.22992C6.36849 0.783305 5.57096 0.559998 4.55469 0.559998C3.55388 0.559998 2.58599 0.772475 1.65103 1.19743C1.2914 1.38153 1.14897 1.82221 1.33281 2.18196L1.54956 2.6061C1.77142 3.04025 2.29497 3.19851 2.74746 3.01699C3.34301 2.77808 3.88161 2.65863 4.36328 2.65863C4.64128 2.65863 4.86686 2.71446 5.04004 2.82611C5.21322 2.93776 5.2998 3.08929 5.2998 3.2807C5.2998 3.52224 5.21891 3.73643 5.05713 3.92328C4.89534 4.11013 4.62988 4.31976 4.26074 4.55219C3.7959 4.84385 3.47233 5.14349 3.29004 5.45111C3.10775 5.75873 3.0166 6.13584 3.0166 6.58246C3.0166 6.90714 3.27981 7.17035 3.60449 7.17035H4.7666Z"
          fill="currentColor"
        />
        <path
          d="M4.16504 10.8686C4.60254 10.8686 4.94775 10.7547 5.20068 10.5268C5.45361 10.2989 5.58008 9.97764 5.58008 9.56293C5.58008 9.14821 5.45817 8.82579 5.21436 8.59564C4.97054 8.3655 4.62077 8.25043 4.16504 8.25043C3.69108 8.25043 3.33219 8.36436 3.08838 8.59222C2.84456 8.82009 2.72266 9.14366 2.72266 9.56293C2.72266 9.9822 2.85026 10.3046 3.10547 10.5302C3.36068 10.7558 3.71387 10.8686 4.16504 10.8686Z"
          fill="currentColor"
        />
        <path
          d="M17.1857 8.17091C17.1857 7.50817 16.6485 6.97091 15.9857 6.97091H9.98571L9.86302 6.97711C9.25791 7.03856 8.78571 7.54959 8.78571 8.17091C8.78571 8.83365 9.32297 9.37091 9.98571 9.37091H15.9857L16.1084 9.36472C16.7135 9.30326 17.1857 8.79223 17.1857 8.17091Z"
          fill="currentColor"
        />
        <path
          d="M17.4714 13.1709C17.4714 12.5082 16.9342 11.9709 16.2714 11.9709H1.7L1.57731 11.9771C0.9722 12.0386 0.5 12.5496 0.5 13.1709C0.5 13.8337 1.03726 14.3709 1.7 14.3709H16.2714L16.3941 14.3647C16.9992 14.3033 17.4714 13.7922 17.4714 13.1709Z"
          fill="currentColor"
        />
        <path
          d="M16.2714 16.9709C16.9342 16.9709 17.4714 17.5082 17.4714 18.1709C17.4714 18.7922 16.9992 19.3033 16.3941 19.3647L16.2714 19.3709H1.7C1.03726 19.3709 0.5 18.8337 0.5 18.1709C0.5 17.5496 0.9722 17.0386 1.57731 16.9771L1.7 16.9709H16.2714Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
